/* Package JSON Import will be here */
import React, { useState } from "react";
import { getTranslate } from "react-localize-redux";
import { useSelector, useDispatch } from "react-redux";
import { Drawer, Tabs, Button, Space, Badge } from "antd";
import { useParams } from "react-router-dom";
/* Package JSON Import will be here */

/* Project Import will be here */
import { Spinner } from "components/Spinner";
import NoData from "components/reusable/NoData";
import ProductSortingAttrFilter from "components/filter/sortingFilter/ProductSortingAttrFilter";
import MobileAttrFilterContent from "components/filter/attrFilter/MobileAttrFilterContent";
import { getAttrFilterList, clearAttrFilter, updateFilterApplied } from "reducers/filter/attrFilter";
import { applyAttributeFilter } from "reducers/products";
import { applyExchangeOrderAttributeFilter } from "reducers/exchange/exchangeOrderProducts";
import { getSalesReturnProductList } from "reducers/salesReturn/salesReturnProducts";
import Constants from "utilities/appConstants";
import { successToast } from "utilities/utils";
import { IGetAttrFilterParams } from "models/filterModels";
import { GAFilterApply } from "hooks/googleAnalyticsHooks";
import { updateSelectedSortingFilter } from "reducers/filter/attrFilter";
/* Project Import will be here */

/* Const,Let & Var will be here */
const { TabPane } = Tabs;
/* Const,Let & Var will be here */

const MobileProductAttrFilter = (props) => {
    const [isShowFilter, setIsShowFilter] = useState(false);
    const [isApiMethodCalled, setApiMethodCalled] = useState(false);

    const { appSettings, translate, attrFilter } = useSelector((state) => ({
        appSettings: state.appSettings,
        translate: getTranslate(state.locale),
        attrFilter: state.attrFilter
    }));

    const dispatch = useDispatch();

    let { category, subcategory } = useParams();

    const clearFilter = () => {
        /* Set isFilterApplied to false */
        dispatch(updateFilterApplied(false));

        /* Clear the applied filter in the local data */
        dispatch(clearAttrFilter());

        /* Make API call to clear the filter and fetch all the data */
        if (props.attrFilterPageType === Constants.PLACE_ORDER_ATTR)
            dispatch(applyAttributeFilter());
        else if (props.attrFilterPageType === Constants.EXCHANGE_ORDER_ATTR)
            dispatch(applyExchangeOrderAttributeFilter());
        else
            dispatch(getSalesReturnProductList());

        /* Filer cleared success message */
        successToast({ content: translate('common.alerts.success.clearFilterSuccess') });
    };

    const applyAttrFilter = () => {
        /*While submit temp value is move to main*/
        dispatch(updateSelectedSortingFilter());
        /* Set isFilterApplied to true */
        dispatch(updateFilterApplied(true));

        /* Make API call to filter and fetch filtered data */
        if (props.attrFilterPageType === Constants.PLACE_ORDER_ATTR)
            dispatch(applyAttributeFilter());
        else if (props.attrFilterPageType === Constants.EXCHANGE_ORDER_ATTR)
            dispatch(applyExchangeOrderAttributeFilter());
        else
            dispatch(getSalesReturnProductList());

        setIsShowFilter(false);

        /* GA - Track filter apply event  */
        if (window.isEnableGA)
            GAFilterApply(props.attrFilterPageType, attrFilter.selectedSortingFilter);
    };

    const checkFilterApplied = () => {
        if (attrFilter.isAttrFilterApplied)
            return true;
        else
            return false;
    }

    const mobileAttrFilterOnClick = () => {
        /* Get the attribute filter list when the config is set to true */
        if (appSettings.isEnableAttrFilter) {
            let requestObject: IGetAttrFilterParams = {
                ids: [],
                isProductAttr: true
            };
            if (subcategory) {
                const splittedSubCat = subcategory.split("_");
                const subCatId = splittedSubCat[splittedSubCat.length - 1];
                requestObject.ids.push(parseInt(subCatId, 10));
            }
            else if (category) {
                const splittedCat = category.split("_");
                const catId = splittedCat[splittedCat.length - 1];
                requestObject.ids.push(parseInt(catId, 10));
            }
            else if (props.selectedSubCatId) {
                requestObject.ids.push(props.selectedSubCatId);
            }
            else if (props.selectedCatId) {
                requestObject.ids.push(props.selectedCatId);
            }
            dispatch(getAttrFilterList(requestObject));
        }

        /* Show the loader during the HTTP request */
        setApiMethodCalled(true);

        /* Show the filter drawer */
        setIsShowFilter(true);
    }
    const renderFilterComponent = () => {
        if (!isApiMethodCalled || attrFilter.isLoading) {
            return (
                <React.Fragment>
                    <div className="container pt-5">
                        <Spinner message={translate("filter.attrFilter.loading")} />
                    </div>
                </React.Fragment>
            );
        }
        else if (attrFilter.data.length <= 0) {
            return (
                <React.Fragment>
                    <div className="container pt-2">
                        <NoData NoDataMessage={translate("filter.attrFilter.noData")} />
                    </div>
                </React.Fragment>
            );
        }
        else {
            return (
                <MobileAttrFilterContent />
            );
        }
    };

    return (
        <React.Fragment>
            <Badge dot={checkFilterApplied()} className="floating-btn-position">
                <Button onClick={() => mobileAttrFilterOnClick()} type="primary" shape="circle" icon={<i className="fa fa-filter fa-lg" aria-hidden="true"></i>} size="default" />
            </Badge>

            <Drawer
                title={
                    <div className="flex items-center">
                        <i
                            className="fa fa-chevron-left mr-4 cursor-pointer"
                            aria-hidden="true"
                            onClick={() => setIsShowFilter(false)}
                        ></i>
                        {translate("filter.productFilter")}
                    </div>
                }
                placement="right"
                visible={isShowFilter}
                className="mobile-attr-filter"
                closable={false}
                footer={
                    <div className="text-right">
                        <Space>
                            <Button onClick={clearFilter} shape="round" size="large">
                                {translate("common.buttons.clear")}
                            </Button>
                            <Button type="primary" onClick={applyAttrFilter} shape="round" size="large">
                                {translate("common.buttons.apply")}
                            </Button>
                        </Space>
                    </div>
                }
            >
                <Tabs defaultActiveKey={appSettings.isEnableAttrFilter ? "2" : "1"} centered>
                    <TabPane tab={translate("filter.sortingFilter.sortBy")} key="1">
                        <ProductSortingAttrFilter pageType={props.attrFilterPageType} />
                    </TabPane>
                    {appSettings.isEnableAttrFilter &&
                        <TabPane tab={translate("filter.filterBy")} key="2">
                            {renderFilterComponent()}
                        </TabPane>
                    }
                </Tabs>

            </Drawer>
        </React.Fragment>
    );
};

export default MobileProductAttrFilter;